// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyB9oJNMLUcDZp-BoGeue2rc6vyUvAKPpdk",
  authDomain: "luckydraw-6305f.firebaseapp.com",
  projectId: "luckydraw-6305f",
  storageBucket: "luckydraw-6305f.appspot.com",
  messagingSenderId: "892639216112",
  appId: "1:892639216112:web:8f9455f7f918a4a49f9d35",
  measurementId: "G-BZ6FD80EDG",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const storage = getStorage(app);
const database = getFirestore(app);

export { app, storage, database };
